import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"

class Plan extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.solicitudes.avanzar}
                postUrl={api.proyectos.solicitudes.avanzar}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"La Solicitud generó el Plan de Trabajo con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Generar Plan de Trabajo"}
                buttonTitle={"Generar Plan de Trabajo"}
                buttonIcon={"fa fa-play fa-lg"}
                
                notAllowedMessage={"La Solicitud ya generó el Plan de Trabajo."}
                saveButton={true}
                saveButtonLabel={"Generar"}
                buttonClass={"btn-success btn-next"}
                closeButton={true}
            >

                <ParadigmaLabeledInput disabled={true} 
                labelColumns={2} fieldColumns={10} 
                label={"Código"} fieldName={"codigo"} />


                <ParadigmaLabeledInput disabled={true} 
                labelColumns={2} fieldColumns={10} 
                label={"Título"} fieldName={"nombre"} />
            </ParadigmaModal>
        );
    }
}

export default Plan;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento1/Plan.js